// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1a04ec5d","455":"8adfb7fa","977":"ee292638"}[chunkId] + ".chunk.js";
};